// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:21
import { TraceItem_abstract } from './../abstract/SagaBase/TraceItem_abstract';
export class TraceItem extends TraceItem_abstract {}
